import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import fallbackPoster from 'src/static/images/not-found/poster-404.png';
import './NotFound.css';

export default function NotFound() {
	return (
		<div id="not-found" className="page">
			<div className="container">
				<img src={fallbackPoster} alt="404 poster" />
				<h1>Not found</h1>
				<Link className="button" to={'/'}>
					<FormattedMessage id="comeback-home" />
				</Link>
			</div>
		</div>
	);
}
